import { api } from "..";

interface CancelCouponsPayload {
  couponIds: string[];
}

export const cancelCoupons = async ({ couponIds }: CancelCouponsPayload) => {
  const res = await api.client.post(`/users-new/coupons/bulk-cancel`, {
    couponIds,
  });
  return res.data;
};
